import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const AdministratorModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState({
    userId: '',
    userName: '',
    workerPhone: '',
    useYn: 'Y',
  });
  const [isData, setIsData] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isIdCheck, setIsIdCheck] = useState(false);
  const [isPhoneCheck, setIsPhoneCheck] = useState(!props.props?.isRegi);

  useEffect(() => {
    if (!props.props?.isRegi && !isData) {
      setItem(props.props?.data.item);
      setIsData(true);
    }
  }, [props]);

  const validation = () => {
    const errors = [
      { check: Common.isEmpty(item.userId), message: 'ID required.' },
      { check: Common.isEmpty(item.userName), message: 'Name required.' },
      { check: Common.isEmpty(item.workerPhone), message: 'Phone required.' },
      { check: props.props?.isRegi && !isIdCheck, message: 'ID verification required.' },
      { check: !isPhoneCheck, message: 'Phone verification required.' }
    ];

    for (const { check, message } of errors) {
      if (check) {
        Common.errorMsg(message);

        return false;
      }
    }

    return true;
  };

  const setUserMst = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const request = props.props?.isRegi ? Server.sendPost : Server.sendPut;

            request('user/mst', item, setUserMstCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const setUserMstCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  const checkUserID = () => {
    if (isIdCheck) return;

    if (Common.isEmpty(item.userId)) {
      Common.errorMsg('ID required.');

      return;
    }

    Server.sendGet('user/id', {
      userId: item?.userId
    }, checkUserIDCallback).then();
  };

  const checkUserIDCallback = res => {
    const checkId = res?.['resultObject'];

    if (checkId['checkUserId'] === 0 && checkId['checkWorkerId'] === 0) {
      setIsIdCheck(true);

      Common.errorMsg('Available.');
    } else {
      Common.errorMsg('ID existing.');

      setItem(() => {
        return {
          ...item,
          userId: '',
        }
      });
    }
  };

  const workerPhoneCheck = () => {
    if (isPhoneCheck) return;

    if (Common.isEmpty(item.workerPhone)) {
      Common.errorMsg('Phone required.');

      return;
    }

    Server.sendGet('workforce/worker/phone', {
      workerPhone: item?.workerPhone
    }, workerPhoneCheckCallback).then();
  };

  const workerPhoneCheckCallback = res => {
    if (res?.['resultCount'] === 0) {
      Common.errorMsg('Available.');

      setIsPhoneCheck(true);
    } else {
      Common.errorMsg('Phone existing.');

      setItem(() => {
        return {
          ...item,
          workerPhone: '',
        }
      });
    }
  };

  return (
    <>
      <CloseBtn onClick={closeModal}/>
      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>Administrator {props.props?.isRegi ? 'Registration' : 'Modify'}</h4>
            </TitHead>
          </Title>
          <ModalForm>
            <FormIn>
              <FormInWrap>
                <label><span>* </span>ID</label>
                <FormInput
                  style={{ width: props.props?.isRegi ? 'calc(55% - 20px)' : 'calc(70% - 10px)' }}
                  type='text'
                  id='userId'
                  name='userId'
                  value={item?.userId}
                  readOnly={!props.props?.isRegi}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        userId: e.target.value,
                      }
                    });
                    setIsIdCheck(false);
                  }}
                />
                {props.props?.isRegi &&
                  <Btn
                    style={{
                      flex: 'none',
                      width: '15%',
                      fontSize: '16px',
                      background: !isIdCheck ? '#0072b9' : '#a4a4a4'
                    }}
                    onClick={checkUserID}
                  >Check</Btn>
                }
              </FormInWrap>
              <FormInWrap>
                <label><span>* </span>Name</label>
                <FormInput
                  type='text'
                  id='userName'
                  name='userName'
                  value={item?.userName}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        userName: e.target.value,
                      }
                    })
                  }}
                />
              </FormInWrap>
            </FormIn>
            <FormIn>
              <FormInWrap>
                <label><span>* </span>Phone</label>
                <FormInput
                  style={{ width: 'calc(55% - 20px)' }}
                  type='text'
                  id='workerPhone'
                  name='workerPhone'
                  value={item?.workerPhone}
                  onChange={e => {
                    e.target.value = Common.onlyNumber(e.target.value);

                    if (e.target.value !== item.phone) {
                      setIsPhoneCheck(false);
                    } else {
                      setIsPhoneCheck(true);
                    }

                    setItem(() => {
                      return {
                        ...item,
                        workerPhone: e.target.value,
                      }
                    });
                  }}
                />
                <Btn
                  style={{
                    flex: 'none',
                    width: '15%',
                    fontSize: '16px',
                    background: !isPhoneCheck ? '#0072b9' : '#a4a4a4'
                  }}
                  onClick={workerPhoneCheck}
                >Check</Btn>
              </FormInWrap>
              <FormInWrap>
                <label><span>* </span>Is Use</label>
                <select
                  name='useYn'
                  id='useYn'
                  value={item?.useYn || ''}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        useYn: e.target.value,
                      };
                    });
                  }}
                >
                  <option value={'Y'}>Y</option>
                  <option value={'N'}>N</option>
                </select>
              </FormInWrap>
            </FormIn>
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
              <Btn $Color onClick={setUserMst}>Submit</Btn>
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 50%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
      color: red;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default AdministratorModal;